<template>
  <div>
    <div v-if="usePlyr">
      <vue-plyr
        v-if="this.mediaSource"
        ref="plyr"
        autoplay
        :crossoriQuegin="true"
      >
        <video
          :src="this.mediaSource.sources[0].src"
          class="video"
          @timeupdate="$emit('timeupdate', $event)"
          @pause="$emit('pause', $event)"
          @stop="$emit('stop', $event)"
          @ended="$emit('ended', $event)"
          @canplay="$emit('canplay', $event)"
        >
          <source
            v-for="s in this.mediaSource.sources"
            :src="s.src"
            :type="s.type"
            :size="s.size"
          />
        </video>
      </vue-plyr>
    </div>
    <div
      v-else-if="!usePlyr"
      :class="
        type === 'classroom'
          ? 'video-player-classroom'
          : 'video-player-question'
      "
    >
      <div class="video">
        <vue-vimeo-player
          :options="{
            responsive: true,
            autoplay: true,
            pip: true,
            speed: true,
            texttrack: false,
          }"
          :autoplay="true"
          :speed="true"
          @timeupdate="$emit('timeupdate', $event)"
          @pause="$emit('pause', $event)"
          @stop="$emit('stop', $event)"
          @ended="$emit('ended', $event)"
          @loaded="$emit('canplay', $event)"
          @play="$emit('play', $event)"
          @enterpictureinpicture="$emit('enterpictureinpicture', $event)"
          ref="plyr"
          :video-url="videoUrl"
          :video-id="videoId"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.video-player-question {
  padding: 0 8.5%;
  overflow: hidden;
}

.video-player-classroom {
  padding: 0 0%;
  margin: 0 auto;
  max-width: 100vh;
  @media screen and (max-width: 764px) {
    max-width: 100%;
  }
}
</style>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import { CONFIG } from "@/config";

export default {
  props: ["mediaSource", "videoId", "type", "videoUrl"],
  components: { vueVimeoPlayer },
  data: function () {
    return {
      usePlyr: CONFIG.USE_PLYR,
    };
  },
};
</script>
